export default () => {
  const csrfTokenElement = document.querySelector('meta[name="csrf-token"]');
  return csrfTokenElement.getAttribute('content');
};
